import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CLabelComponent } from './c-label.component';
import { TrustHtmlModule } from 'src/app/pipes/trust-html/trust-html.module';
import { FetchImageFromHtmlModule } from 'src/app/pipes/fetch-image-from-html/fetch-image-from-html.module';
import { CTooltipButtonModule } from '../c-tooltip-button/c-tooltip-button.module';



@NgModule({
  declarations: [CLabelComponent],
  imports: [
    CommonModule,
    IonicModule,
    TrustHtmlModule,
    FetchImageFromHtmlModule,
    CTooltipButtonModule,
  ],
  exports: [CLabelComponent]
})
export class CLabelModule { }
